import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./terms-modal.scss";
import {DeprecatedModalService2} from "../../../../../../common/design2/modal-service/modal-service";
import {consumeContext} from "../../../../../../../../react/context";

export const TermsModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => DeprecatedModalService2({
        render: (_, rm) => ({
            size: "medium",
            top: 60,
            content: next({
                close: () => rm(),
            }),
        }),
        xdQaName: "Terms and Conditions",
        next: rootNext,
    })],
    consumeContext("apis"),
    // ["agreement", ({apis}, next) => Load2({
    //     fetch: () => apis.next.getCustomerAgreement(),
    //     next,
    // })],
    ({modal, agreement}) => (
        <div className="terms-modal-722">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Terms and Conditions Title">
                    Terms and Conditions
                </div>
            </div>

            <div className="content" xd-qa-type="label" xd-qa-name="Terms and Conditions Message">

                {/*{agreement.loading && (*/}
                {/*    <div className="loading">*/}
                {/*        Loading...*/}
                {/*    </div>*/}
                {/*)}*/}
                {/*{agreement.value?.map((a) => (*/}
                {/*    <div className="agreement" dangerouslySetInnerHTML={{__html: a.description}}/>*/}
                {/*))}*/}

                <hr/>

                <em>
                    This is a legally binding agreement, so please read it carefully.
                </em>

                <p>
                    This Agreement shall be effective on the date that you first accept the terms of this Agreement (“Effective Date”). Xpressdocs grants to you a limited, non-exclusive rental use of the data subject to the following:
                </p>

                <p>
                    The data you are about to receive is on a rental basis for either one time use, or multi-use. If you did not indicate multi-use as part of your list query, then you understand by default the use of this list is for one time use only. You further acknowledge that the list you are about to rent is seeded to detect any unauthorized use or duplication thereof, and agree to pay for the full multiple use charge for any unauthorized use or duplication of the list.
                </p>

                <em>
                    Your Responsibility
                </em>

                <ul>
                    <li>
                        You may choose to replace the recipient’s name with other text of your choosing when you set up your list.
                    </li>
                    <li>
                        It is your responsibility to view and approve the found addresses before ordering.
                    </li>
                    <li>
                        As part of our service, we host your active mailing lists at no charge. In the event a list is not used for a period of eighteen (18) consecutive months, it will be permanently deleted from our system.
                    </li>
                    <li>
                        No refunds or credits will be issued for a list you have approved.
                    </li>
                </ul>

                <p>
                    <u>Compliance with Direct Marketing Association’s Name Suppression List</u> Consumers that don’t want unsolicited mail subscribe to the Direct Marketing Association’s Name Suppression List. The provider of this data uses this list to omit these consumers from the database. Consumers also write in, phone in, and mail in their request to be eliminated from the databases directly to the database provider. Our provider uses all of these sources to create their own Name Suppression files and then deletes them from the master database we use to update our system quarterly. Please feel free to contact us immediately if you have a problem involving a recipient complaint. We will be happy to help.
                </p>

                <p>
                    <b>By agreeing, you accept all of the terms and conditions described herein.</b> If you do not agree with the terms and conditions of this agreement, choose to go "Back", and select an alternate distribution option.
                </p>

            </div>

            <div className="footer">
                <button {...{
                    className: "next",
                    onClick: modal.close,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Terms and Conditions Close",
                }}>
                    Close
                </button>
            </div>
        </div>
    ),
);
